import { useTheme } from '@mui/material';
import { Line, LineProps } from '@nivo/line';
import { Dimensions } from '@nivo/core';

const LineChart: React.FC<LineProps & Dimensions> = ({ ...restProps }) => {
  const theme = useTheme();
  
  return (
    <Line
      theme={{
        axis: {
          ticks: {
            line: {
              stroke: theme.palette.grey[500],
            },
            text: {
              fill: theme.palette.grey[500],
              fontWeight: 600,
            },
          },
        },
        grid: {
          line: {
            stroke: theme.palette.grey[100],
            strokeWidth: 1,
            strokeDasharray: '4 4',
          },
        },
        crosshair: {
          line: {
            stroke: theme.palette.primary[700],
            strokeWidth: 2,
          },
        },
      }}
      lineWidth={4}
      margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
      animate
      colors={theme.palette.primary.main}
      xScale={{
        type: 'point',
      }}
      yScale={{
        type: 'linear',
      }}
      axisLeft={{
        legendOffset: 12,
        tickValues: 6,
        tickSize: 0,
        tickPadding: 14,
      }}
      axisBottom={{
        tickSize: 0,
        tickPadding: 14,
      }}
      curve='monotoneX'
      enableGridX={false}
      pointSize={0}
      enableSlices={false}
      useMesh
      enableCrosshair
      crosshairType='bottom'
      {...restProps}
    />
  );
};

export default LineChart;
